import { UserModel } from './UserModel';

export class UserBirthdayModel extends UserModel {
    constructor(userData) {
        super(userData);

        this._birthdayUser = {
            ...this._user,
            birth: userData.birth,
        };
    }

    get userBirthday() {
        return this._birthdayUser;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/UserBirthdayModel.js